<template>
  <div class="audio-player">
    <audio
      :src="src"
      ref="audioPlayerRef"
      v-show="true"
      @canplay="getDuration"
      @timeupdate="getCurrentTime"
      @ended="ended"
    >
      你的浏览器不支持audio标签
    </audio>
    <div class="audio-block">
      <div class="play-content">
        <i
          :class="['iconfont play-icon', isPlay ? 'icon-pause' : 'icon-play']"
          @click="handlePlay"
        />
        <div class="start">{{ transferSeconds2Minutes(current) }}</div>
        <el-slider
          class="slider"
          v-model="progress"
          stroke-width="10"
          @mousedown="mousedown"
          @mouseup="mouseup"
          @change="changeProgress"
          @input="progressInput"
          :show-tooltip="false"
        />
        <div class="end">{{ transferSeconds2Minutes(duration) }}</div>
      </div>
      <div class="userInfo">
        <div>
          <template v-if="rowData?.from === 'wx'">微信语音</template>
          <template v-else-if="rowData?.from === 'callRecording'">首访录音</template>
          <template v-else-if="rowData?.from === 'mo'">录音</template>
          <template v-else>
            <span>联系人：{{ rowData?.linkName || '-' }}</span>
            <span class="tw-ml-[16px]">员工：{{ rowData?.userName || '-' }}</span>
          </template>
        </div>
        <div class="speed">
          <span>播放速度</span>
          <div
            :class="speed === item.value ? 'active speed-item' : 'speed-item'"
            v-for="(item, index) in speedList"
            :key="index"
            @click="handleCommand(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type PropType, ref } from 'vue'

const audioPlayerRef = ref()
const current = ref(0)
const progress = ref(0)
const speed = ref(1)
const isEnd = ref<boolean>(false)
const isPlay = ref<boolean>(false)
const speedList = [
  {
    label: '1x',
    value: 1
  },
  {
    label: '2x',
    value: 2
  },
  {
    label: '3x',
    value: 3
  }
]
const duration = ref(0)

const props = defineProps({
  src: {
    type: String,
    default: () => {
      'blob:http://localhost:8080/3c436ec4-0818-4a4f-9238-96a966d29afc'
    }
  },
  rowData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})

function getCurrentTime() {
  current.value = audioPlayerRef.value?.currentTime || 0
  progress.value = (audioPlayerRef.value?.currentTime / duration.value) * 100 || 0
}
function handleCommand(command: number) {
  audioPlayerRef.value.playbackRate = command
  speed.value = command
}

function handlePlay() {
  if (isPlay.value) {
    stop()
  } else {
    play()
  }
}

onMounted(() => {
  // 微信语音自动播放
  if (
    props.rowData?.from === 'wx' ||
    props.rowData?.from === 'callRecording' ||
    props.rowData?.from === 'mo'
  ) {
    setTimeout(() => {
      handlePlay()
    }, 1000)
  }
})

function play() {
  if (audioPlayerRef.value.duration) {
    if (isEnd.value) {
      current.value = 0
      progress.value = 0
    }
    isPlay.value = true
    audioPlayerRef.value.play()
  } else {
    getDuration()
    ElMessage.error('获取录音失败')
  }
}
function stop() {
  isPlay.value = false
  audioPlayerRef.value && audioPlayerRef.value.pause()
}
function getDuration() {
  console.log(audioPlayerRef.value.duration, 'audioPlayerRef.value')
  duration.value = audioPlayerRef.value?.duration
}
// 拖动进度条
function changeProgress(val: number) {
  console.log(val, 'changeProgress')
  if (!duration.value) {
    return
  }
  const ct = (val * duration.value) / 100
  if (!isNaN(ct)) {
    audioPlayerRef.value.currentTime = ct
    audioPlayerRef.value.play()
  }
}
function progressInput(val: number) {
  console.log(val, 'progressInput')
  if (!duration.value) {
    return
  }
  current.value = (val * duration.value) / 100
  if (!isNaN(current.value)) {
    audioPlayerRef.value.currentTime = current.value
  }
}
// 转换时间格式
function transferSeconds2Minutes(seconds: number): string {
  const duration: number = Math.floor(seconds)
  let minute: string = Math.floor(duration / 60)
    .toString()
    .padStart(2, '0')
  let sec: string = (duration % 60).toString().padStart(2, '0')
  return minute + ':' + sec
}

function ended() {
  isPlay.value = false
  isEnd.value = true
}
function mousedown() {
  if (!duration.value) {
    return
  }
  audioPlayerRef.value && audioPlayerRef.value.pause()
}
function mouseup() {
  if (!duration.value) {
    return
  }
  isPlay.value = true
  audioPlayerRef.value.play()
}
defineExpose({
  play,
  stop
})
</script>

<style lang="scss" scoped>
.audio-player {
  .audio-block {
    .play-content {
      @include flex-center(row, normal, center);
      .play-icon {
        font-size: 28px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.7);
      }
      .slider {
        padding: 0 16px;
      }
      .start {
        flex: 1;
        color: rgba(255, 255, 255, 0.7);
        padding-left: 18px;
      }
      .end {
        flex: 1;
        color: rgba(255, 255, 255, 0.7);
      }
    }
    .userInfo {
      @include flex-center(row, space-between, center);
      font-size: $font-size-small;
      color: rgba(255, 255, 255, 0.7);
      margin-top: 16px;
      .speed {
        @include flex-center(row, normal, center);
        .speed-item {
          cursor: pointer;
          margin-left: 9px;
        }
        .speed-item.active {
          border: 1px solid #fff;
          border-radius: 2px;
          color: #fff;
          padding: 2px 8px;
        }
      }
    }
  }
}
</style>
